import { useTheme } from "@mui/material";
import { useEffect, type FC } from "react";
import {
  ReactCompareSlider,
  ReactCompareSliderHandle,
  ReactCompareSliderImage,
  useReactCompareSliderRef,
} from "react-compare-slider";

type AutoCompareSliderProps = {
  img1Src: string;
  img2Src: string;
};

export const AutoCompareSlider: FC<AutoCompareSliderProps> = ({
  img1Src,
  img2Src,
}) => {
  const theme = useTheme();
  const reactCompareSliderRef = useReactCompareSliderRef();

  useEffect(() => {
    let position = 100;

    const fireTransition = async () => {
      await new Promise((resolve) =>
        setTimeout(() => {
          position -= 1;
          if (position < 0) position = 100;
          reactCompareSliderRef.current?.setPosition(position);
          resolve(true);
        }, 10)
      );
    };

    const id = setInterval(() => fireTransition(), 50);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ReactCompareSlider
      ref={reactCompareSliderRef}
      itemOne={<ReactCompareSliderImage src={img1Src} alt="Origin Image" />}
      itemTwo={<ReactCompareSliderImage src={img2Src} alt="Magic Image" />}
      style={{
        width: `180px`,
        height: `180px`,
        borderRadius: "5px",
        border: `1px solid ${theme.palette.secondary.dark}`,
        boxShadow: `0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)`,
      }}
      handle={
        <ReactCompareSliderHandle
          buttonStyle={{ display: "none" }}
          linesStyle={{
            color: theme.palette.secondary.dark,
            width: 1,
            boxShadow: "none",
          }}
        />
      }
      position={100}
      disabled
    />
  );
};
